(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'MyTripsAccountClientWhereToNextDestinations',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('select#mytripsaccountclientwheretonextdestinations-where_to_next').change(function changing(e) {
			// loop thru all options of hidden multi select input
			$('#mytripsaccountclientwheretonextdestinations-where_to_next option').each(function selecting(e, val) {
				var $self = $(this);
				
				// show span under select
				if ($self.is(":selected")) {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').removeClass('hidden');
				// hide span
				} else {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').addClass('hidden');
				}
			});
		}).trigger('change');

		$('.reset-destinations').on('click', function resetSelectPicker(e) {
			e.preventDefault();
			$('select#mytripsaccountclientwheretonextdestinations-where_to_next').val('').trigger('change');
		});
	};

}(jQuery, window.Adzuki || {}));
